import areaJSON from './area.json';

interface Area {
  id: string;
  name: string;
  fullName: string;
  location: {
    lat: number;
    lng: number;
  };
  pinyin: string[];
  children?: Area[];
}

const area = areaJSON as unknown as Area[];

const index: Record<string, { path: string; ids: string[] }> = {};

function fillIndex(
  data: Area[],
  preNames: string[] = [],
  preIds: string[] = []
) {
  data.map((item, i) => {
    const names = preNames.concat([item.name || item.fullName]);
    const ids = preIds.concat([item.id]);
    index[item.id] = { path: names.join(' / '), ids };
    if (item.children) {
      fillIndex(item.children, names, ids);
    }
  });
}

fillIndex(area);
export function getArea(name: string) {
  return index[name];
}

interface Option {
  value: string;
  label: string;
  children?: Option[];
}

const zhiXiaShi = ['北京', '天津', '台湾', '香港', '澳门'];

function getOptionsInner(deep: number, data: Area[]): Option[] {
  return data.map((i) => {
    const newDeep = zhiXiaShi.indexOf(i.name) !== -1 ? deep - 2 : deep - 1;
    return {
      value: i.id,
      label: i.name || i.fullName,
      children:
        !i.children || newDeep < 0
          ? undefined
          : getOptionsInner(newDeep, i.children),
    };
  });
}

const deepMap = {
  province: 0,
  city: 1,
  district: 2,
};

export function getOptions(type?: keyof typeof deepMap) {
  const index = deepMap[type || 'district'];
  return getOptionsInner(index, area);
}
